<template>
<div>
    <BlockUI v-if="busy">
        <div class="loader"></div>
    </BlockUI>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">รายงานยอดรวมค่าคอมมิชชั่นสำหรับ SHOP</h1>
                <p class="text-white pb-0 px-3">สรุปยอดรวมคาคอมมิชชั่นในแต่ละเดือนของพนักงาน</p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 align-self-center text-right">
                <h1 class="display-3 text-white" v-if="selectedTab=='shop_cod'">
                    <h3 class="text-white">ยอดรวมคอมมิชชั่นสุทธิ: {{parseFloat(totalNetCommission).toFixed(2)}}</h3>
                    <h3 class="text-white">ทั้งหมด: {{ selected.length}} ร้าน</h3>
                    <button class="btn btn-xl btn-success px-4" @click="confirmCreateBill" :disabled="selected.length < 1">สร้างบิลโอนเงิน</button>
                </h1>
                <h1 class="display-3 text-white" v-else-if="selectedTab!='shop_cod'">
                    <h3 class="text-white">ยอดรวมคอมมิชชั่นสุทธิ: {{parseFloat(totalNetCommission).toFixed(2)}}</h3>
                    <h3 class="text-white">ทั้งหมด: {{ selected.length}} ร้าน</h3>
                    <vue-excel-xlsx class="btn btn-xl btn-success px-4" 
                        :data="selected" 
                        :disabled="selected.length < 1"
                        :columns="(selectedTab == 'shop_bill')? shopExportFields : superAdminExportFields" 
                        :filename="(selectedTab=='shop_bill') ? 'โอนเงิน shop' : 'โอนเงิน superadmin'" 
                        :sheetname="(selectedTab=='shop_bill') ? 'โอนเงิน shop' : 'โอนเงิน superadmin'">
                        ดาวน์โหลด Excel สำหรับโอนเงิน
                    </vue-excel-xlsx>
                </h1>
            </div>
        </div>
    </base-header>
    <div class="container-fluid mt--4 mb-5">
        <div class="row">
            <div class="col">
                <div id="billtab-bar" class="mt--5">
                    <b-tabs v-model="tabIndex" content-class="" class="billtabs">
                        <b-tab title="รายงานคอมมิชชั่น" class="billtab" @click="selectTab('shop_cod')" active>
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                                        <div class="form-group mb-0">
                                            <label class="text">วันที่ขนส่งโอนเงินคืนแล้ว (วันเริ่มต้น - วันสุดท้าย)</label><label class="mb-0 p-custom text-muted"></label>
                                            <div class="row">
                                                <div class="col-6 col-md-4 col-lg-4 content--">
                                                    <input type="date" v-model="filters.date_start" class="form-control" @input="$v.filters.date_start.$touch" :class="{ 'is-invalid': $v.filters.date_start.$dirty && ($v.filters.date_start.$invalid)}" />
                                                </div>
                                                <div class="col-6 col-md-4 col-lg-4 mb-3">
                                                    <input type="date" v-model="filters.date_end" class="form-control" @input="$v.filters.date_end.$touch" :class="{ 'is-invalid': $v.filters.date_end.$dirty && ($v.filters.date_end.$invalid)}" />
                                                </div>
                                                <div class="col-12 col-md-3 col-lg-4">
                                                    <button class="btn btn-info btn-sm-res" @click="getReportShopCODCommission()">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                    <button class="btn btn-info" @click="showAll()" :disabled="items.length<1">
                                                        แสดงข้อมูลทั้งหมด
                                                    </button>
                                                    <vue-excel-xlsx class="btn btn-info" 
                                                        :data="selected"
                                                        :columns="columnCommissionShop"
                                                        :filename="'รายงานคอมมิชชั่น'"
                                                        :sheetname="'รายงานคอมมิชชั่น'">
                                                        Export
                                                    </vue-excel-xlsx>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                </div>
                            </div>
                            <ShopCODCommission :items="items" :fields="fields" :search="search" :selected="selected" @onRowSelected="onRowSelected" ref="reportShopCODCommission" @selectAllRows="selectAllRows" :totalItems="totalItems"></ShopCODCommission>
                        </b-tab>
                        <b-tab title="โอนเงิน (SHOP)" class="billtab" @click="selectTab('shop_bill')">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="form-group mb-0">
                                            <label class="text">วันที่สร้างบิล (วันเริ่มต้น - วันสุดท้าย)</label><label class="mb-0 p-custom text-muted"></label>
                                            <div class="row">
                                                <div class="col-6 col-md-4 col-lg-6 content--">
                                                    <input type="date" v-model="filtersBill.date_start" class="form-control" @input="$v.filtersBill.date_start.$touch" :class="{ 'is-invalid': $v.filtersBill.date_start.$dirty && ($v.filtersBill.date_start.$invalid)}" />
                                                </div>
                                                <div class="col-6 col-md-4 col-lg-6 mb-3">
                                                    <input type="date" v-model="filtersBill.date_end" @input="$v.filtersBill.date_end.$touch" class="form-control" :class="{ 'is-invalid': $v.filtersBill.date_end.$dirty && ($v.filtersBill.date_end.$invalid && !$v.filtersBill.date_end.maxValue)}" />
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="form-group mb-0">
                                            <div class="row">
                                                <div class="col-6 col-md-4 col-lg-6">
                                                    <b-form-group id="input-group-1" label="ค้นหาธนาคาร" label-for="input-1" class="mb-0 col">
                                                        <select class="form-control" @click.stop.prevent v-model="selectedBank">
                                                            <option :value="false">{{bankList.length == 0 ? 'ดูทั้งหมด' : 'ดูทั้งหมด'}}</option>
                                                            <!-- <option :value="bank.code" v-for="bank in bankList" :key="bank.code">{{ bank.name }}</option> -->
                                                            <option :value="bank" v-for="bank in bankList" :key="bank.code">{{ bank.name }}</option>
                                                        </select>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-6 col-md-4 col-lg-6">
                                                    <b-form-group id="input-group-1" label="ค้นหาสถานะ" label-for="input-1" class="mb-0 col">
                                                        <select class="form-control" @click.stop.prevent v-model="selectedStatus">
                                                            <option :value="false">ดูทั้งหมด</option>
                                                            <option value="wait">รอโอน</option>
                                                            <option value="transferred">โอนเงินแล้ว</option>
                                                        </select>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="form-group mb-0 col-xl-12 text-right">
                                            <div class="row">
                                                <button class="btn btn-info btn-sm-res" @click="getBill('shop')">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <div class="text-right">
                                                    <button class="btn btn-info" @click="showAll()" :disabled="shopBills.length<1">
                                                        แสดงข้อมูลทั้งหมด
                                                    </button>
                                                    <button class="btn btn-success btn-sm-res" @click="confirmUpdateShopBill()" :disabled="disableUpdateTransferred()">
                                                        ยืนยันรายการโอนเงิน
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <hr class="d-md-none d-lg-none" />

                                    </div>
                                </div>
                            </div>
                            <BillTable :items="shopBills" :totalItems="shopBills.length" :fields="shopBillFields" :search="search" :selected="selected" @onRowSelected="onRowSelected" ref="shopBillRef" :checkSelect="checkSelect" @selectAllRows="selectAllRows"></BillTable>
                        </b-tab>
                        <b-tab title="โอนเงิน (SUPERADMIN)" class="billtab" @click="selectTab('superadmin_bill')">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="form-group mb-0">
                                            <label class="text">วันที่สร้างบิล (วันเริ่มต้น - วันสุดท้าย)</label><label class="mb-0 p-custom text-muted"></label>
                                            <div class="row">
                                                <div class="col-6 col-md-4 col-lg-6 content--">
                                                    <input type="date" v-model="filtersBill.date_start" class="form-control" @input="$v.filtersBill.date_start.$touch" :class="{ 'is-invalid': $v.filtersBill.date_start.$dirty && ($v.filtersBill.date_start.$invalid)}" />
                                                </div>
                                                <div class="col-6 col-md-4 col-lg-6 mb-3">
                                                    <input type="date" v-model="filtersBill.date_end" @input="$v.filtersBill.date_end.$touch" class="form-control" :class="{ 'is-invalid': $v.filtersBill.date_end.$dirty && ($v.filtersBill.date_end.$invalid && !$v.filtersBill.date_end.maxValue)}" />
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="form-group mb-0">
                                            <div class="row">
                                                <div class="col-6 col-md-4 col-lg-6">
                                                    <b-form-group id="input-group-1" label="ค้นหาธนาคาร" label-for="input-1" class="mb-0 col">
                                                        <select class="form-control" @click.stop.prevent v-model="selectedBank">
                                                            <option :value="false">{{bankList.length == 0 ? 'ดูทั้งหมด' : 'ดูทั้งหมด'}}</option>
                                                            <!-- <option :value="bank.code" v-for="bank in bankList" :key="bank.code">{{ bank.name }}</option> -->
                                                            <option :value="bank" v-for="bank in bankList" :key="bank.code">{{ bank.name }}</option>
                                                        </select>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-6 col-md-4 col-lg-6">
                                                    <b-form-group id="input-group-1" label="ค้นหาสถานะ" label-for="input-1" class="mb-0 col">
                                                        <select class="form-control" @click.stop.prevent v-model="selectedStatus">
                                                            <option :value="false">ดูทั้งหมด</option>
                                                            <option value="wait">รอโอน</option>
                                                            <option value="transferred">โอนเงินแล้ว</option>
                                                        </select>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="form-group mb-0 col-xl-12 text-right">
                                            <div class="row">
                                                <button class="btn btn-info btn-sm-res" @click="getBill('superadmin')">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <div class="text-right">
                                                    <button class="btn btn-info" @click="showAll()" :disabled="superAdminBills.length<1">
                                                        แสดงข้อมูลทั้งหมด
                                                    </button>
                                                    <button class="btn btn-success btn-sm-res" @click="confirmUpdateSuperAdminBill()" :disabled="selected.length < 1">
                                                        ยืนยันรายการโอนเงิน
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="d-md-none d-lg-none" />

                                    </div>
                                </div>
                            </div>
                            <BillTable :items="superAdminBills" :totalItems="superAdminBills.length" :fields="superAdminBillFields" :search="search" :selected="selected" @onRowSelected="onRowSelected" ref="superAdminBill" :checkSelect="checkSelect" @selectAllRows="selectAllRows"></BillTable>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ShopCODCommission from '@/components/custom/reports/cod/ShopCODCommission'
import BillTable from '@/components/custom/reports/cod/BillTable'
import ShopCODCommissionFields from '@/constants/ShopCODCommission'
import BillFields from '@/constants/BillFields'
import moment from 'moment'
import {
    required
} from "vuelidate/lib/validators"
import validatePop from "@/plugins/validatePop.js"
import formatBank from '@/plugins/formatBank.js';

export default {
    components: {
        ShopCODCommission,
        BillTable
        // Management
    },
    validations: {
        filters: {
            date_start: {
                required
            },
            date_end: {
                required,
                validEndDate(value) {
                    return moment(value).valueOf() < moment().add(-1, 'day').endOf('day').valueOf()
                }
            },
        },
        filtersBill: {
            date_start: {
                required
            },
            date_end: {
                required
            },
        }
    },
    data() {
        return {
            columnCommissionShop: [
                {
                    label: "รหัสร้าน",
                    field: "shop_code"
                },
                {
                    label: "ชื่อร้าน",
                    field: "shop_name"
                },
                {
                    label: "ประเภทลูกค้า",
                    field: "customer_type"
                },
                {
                    label: "จำนวนพัสดุ",
                    field: "nums"
                },
                {
                    label: "ยอดรวม COD",
                    field: "cod_amount"
                },
                {
                    label: "ยอดรวม Commission",
                    field: "commission"
                },
                {
                    label: "หักภาษี ณ ที่จ่าย",
                    field: 'withholding_tax'
                },
                {
                    label: "ยอด Commission ก่อน VAT 7%",
                    field: 'exclude_vat'
                }

            ],
            bankList: [{
                    type: 'scb',
                    code: '014',
                    name: "ไทยพาณิชย์ (SIAM COMMERCIAL)"
                },
                {
                    type: 'other',
                    code: false,
                    name: "ธนาคารอื่นๆ ที่ไม่ใช่ไทยพาณิชย์"
                },
            ],
            bankName: {},
            tabIndex: 0,
            totalNetCommission: 0,
            selectedBank: false,
            selectedStatus: false,
            busy: false,
            selectedTab: 'shop_cod',
            checkSelect: false,
            items: [],
            totalItems: 0,
            fields: ShopCODCommissionFields,
            selected: [],
            // bill fields
            shopBills: [],
            shopBillFields: BillFields.shop,
            shopExportFields: BillFields.shopExportNew,
            // super admin
            superAdminBills: [],
            superAdminBillFields: BillFields.superAdmin,
            superAdminExportFields: BillFields.superAdminExport,
            filterSelectDate: 'created_at',
            filters: {
                date_start: '',
                date_end: moment().add(-1, 'day').valueOf(),
                // max_date_end: moment().add(-1, 'day').format('YYYY-MM-DD')
            },
            filtersBill: {
                date_start: moment().format('yyyy-MM-dd'),
                date_end: moment().format('yyyy-MM-dd')
            },
            search: {
                status: false,
                selectedBank: false,
                page: 1,
                perPage: 100,
            },
        }
    },
    mounted() {
        formatBank.forEach((bank) => {
            this.bankName[bank.code] = bank
        })
    },
    methods: {
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: OkmsgTitle,
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
        confirmUpdateSuperAdminBill() {
            this.$bvModal.msgBoxConfirm('ทำรายการทั้งหมด: '+ this.selected.length + 'ร้าน\n' + 'จำนวน: '+ this.totalNetCommission, {
                title: "กรุณายืนยัน",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ยืนยัน",
                cancelTitle: "ยกเลิก",
                contentClass: "modal-confirm-text",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value)
                    this.updateShopBill()
            })
        },
        showAll() {
            this.$bvModal.msgBoxConfirm('แสดงทั้งหมดเว็บอาจจะโหลดช้าหน่อยถ้าข้อมูลเกิน 1000 แถว', {
                title: "กรุณายืนยัน",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ยืนยัน",
                cancelTitle: "ยกเลิก",
                contentClass: "modal-confirm-text",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value)
                    this.search.perPage = 1000000;
            })
        },
        disableUpdateTransferred() {
            if (!this.selected.length) {
                return true;
            }
            let disabled = false;
            this.selected.forEach((i) => {
                if (i.status == 'transferred')
                    disabled = true;
            })
            return disabled;
        },
        applyFilter() {
            let items;
            if (this.selectedTab == 'shop_bill') {
                items = this.shopBills
            } else if (this.selectedTab == 'superadmin_bill') {
                items = this.superAdminBills
            }
            if (this.selectedBank) {
                items = items.filter(item => {
                    if (this.selectedBank) {
                        if (this.selectedBank.type == 'other' && item.bank_code != '014')
                            return true
                        if (this.selectedBank.type == 'scb' && this.selectedBank.code === item.bank_code)
                            return true
                    }
                })
            }
            if (this.selectedStatus) {
                items = items.filter(item => {
                    if (this.selectedStatus && this.selectedStatus == item.status)
                        return true
                })
            }

            if (this.selectedTab == 'shop_bill') {
                this.shopBills = items
            } else if (this.selectedTab == 'superadmin_bill') {
                this.superAdminBills = items
            }
        },
        onRowSelected(items) {
            this.selected = items
            if (this.selectedTab == 'shop_cod') {
                this.totalNetCommission = items.reduce((total, item) => {
                    total += item.net_commission
                    return total
                }, 0);
            } else {
                this.totalNetCommission = items.reduce((total, item) => {
                    total += parseFloat(item.net)
                    return total
                }, 0);
            }

        },
        selectAllRows() {
            if (this.selectedTab == 'shop_cod') {
                if (this.items.length < 1) {
                    return false
                }
                this.checkSelect = !this.checkSelect
                if (this.checkSelect) {
                    this.$refs.reportShopCODCommission.$refs.ShopCODCommissionTable.selectAllRows()
                } else {
                    this.$refs.reportShopCODCommission.$refs.ShopCODCommissionTable.clearSelected()
                }
            } else if (this.selectedTab == 'shop_bill') {
                if (this.shopBills.length < 1) {
                    return false
                }
                this.checkSelect = !this.checkSelect
                if (this.checkSelect) {
                    this.$refs.shopBillRef.$refs.billTable.selectAllRows()
                } else {
                    this.$refs.shopBillRef.$refs.billTable.clearSelected()
                }
            } else if (this.selectedTab == 'superadmin_bill') {
                if (this.superAdminBills.length < 1) {
                    return false
                }
                this.checkSelect = !this.checkSelect
                if (this.checkSelect) {
                    this.$refs.superAdminBill.$refs.billTable.selectAllRows()
                } else {
                    this.$refs.superAdminBill.$refs.billTable.clearSelected()
                }
            }

        },
        unselectAllRows() {
            this.$refs.reportShopCODCommission.$refs.ShopCODCommissionTable.clearSelected()
            this.$refs.shopBillRef.$refs.billTable.clearSelected()
            this.$refs.superAdminBill.$refs.billTable.clearSelected()
        },
        selectTab(tab) {
            // this.selected =[];
            this.checkSelect = false;
            this.filters.date_start = moment();
            this.filters.date_end = moment();
            this.selectedTab = tab
            this.unselectAllRows();
            this.tabIndex = 0
            if (tab === 'shop_bill') {
                this.tabIndex = 1
                this.getBill('shop')
            }
            if (tab === 'superadmin_bill') {
                this.tabIndex = 2
                this.getBill('superadmin')
            }
        },
        confirmCreateBill() {
            this.$bvModal.msgBoxConfirm('ทำรายการทั้งหมด: '+ this.selected.length + 'ร้าน\n' +
            'จำนวน: ' + parseFloat(this.totalNetCommission).toFixed(2) + ' บาท', {
                title: "กรุณายืนยัน",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ยืนยัน",
                cancelTitle: "ยกเลิก",
                contentClass: "modal-confirm-text",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value)
                    this.createBill()
            })
        },
        confirmUpdateShopBill() {
            this.$bvModal.msgBoxConfirm('ทำรายการทั้งหมด: '+ this.selected.length + 'ร้าน\n' + 'จำนวน: '+ this.totalNetCommission, {
                title: "กรุณายืนยัน",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ยืนยัน",
                cancelTitle: "ยกเลิก",
                contentClass: "modal-confirm-text",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value)
                    this.updateShopBill()
            })
        },
        createBill() {
            if (this.filters.date_start > this.filters.date_end) {
                alert('วันสุดท้ายต้องมากกว่าวันเริ่มต้น')
            }
            if (this.filters.date_end > moment().add(-1, 'day').format()) {
                alert('วันสุดท้ายต้องน้อยกว่าวันที่ปัจจุบัน')
            }
            const list_shop_id = []
            this.selected.forEach((i) => {
                list_shop_id.push(i.shop_id)
            });
            this.busy = true;
            this.$http
                .post(this.$API_URL + "/shippop/commission/bill/cod", {
                    date_start: moment(this.filters.date_start).format('DD-MM-YYYY'),
                    date_end: moment(this.filters.date_end).format('DD-MM-YYYY'),
                    exclude_vat: 7,
                    withholding_tax: 3,
                    list_shop_id: list_shop_id
                }, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                })
                .then(res => {
                    this.busy = false;
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    if (res.data.status) {
                        this.selectTab('shop_bill')
                        return;
                    }
                    this.items = res.data.data
                    this.totalItems = res.data.data.length
                    this.busy = false
                });
        },
        updateShopBill() {
            if (!confirm('ยืนยัน')) {
                return;
            }
            const list_bill_id = []
            this.selected.forEach((i) => {
                list_bill_id.push(i.id)
            });
            this.busy = true;
            this.$http
                .put(this.$API_URL + "/shippop/commission/status/bill/cod", {
                    exclude_vat: 7,
                    withholding_tax: 3,
                    list_bill_id: list_bill_id,
                    status: 'transferred'
                }, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                })
                .then(res => {
                    this.busy = false;
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.getBill('shop')
                });
        },
        updateSuperAdminBill() {
            const list_bill_id = []
            this.selected.forEach((i) => {
                list_bill_id.push(i.id)
            });
            this.busy = true;
            this.$http
                .put(this.$API_URL + "/shippop/commission/superadmin/status/bill/cod", {
                    // exclude_vat: 7,
                    // withholding_tax: 3,
                    list_bill_id: list_bill_id,
                    status: 'transferred'
                }, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                })
                .then(res => {
                    this.busy = false;
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.getBill('superadmin')
                });
        },
        getReportShopCODCommission() {
            this.busy = true;
            this.$http
                .get(this.$API_URL + "/shippop/commission/order/cod", {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    params: {
                        date_start: this.filters.date_start,
                        date_end: this.filters.date_end,
                        exclude_vat: 7,
                        withholding_tax: 3
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.busy = false;
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.search.perPage = 100;
                    this.items = res.data.data.map((i) => {
                        let netCommission;
                        if (i.customer_type === 'person') {
                            netCommission = parseFloat(parseFloat(i.commission).toFixed(2))
                        } else {
                            netCommission = parseFloat(parseFloat(parseFloat(i.commission) - parseFloat(i.withholding_tax)).toFixed(2))
                        }
                        return {
                            ...i,
                            net_commission: netCommission
                        }
                    })

                    this.totalItems = res.data.data.length
                    this.busy = false
                });
        },
        getBill(type) {
            this.busy = true;
            this.$http
                .get(this.$API_URL + "/shippop/commission/bill/cod", {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    params: {
                        date_start: moment(this.filtersBill.date_start).format('YYYY-MM-DD'),
                        date_end: moment(this.filtersBill.date_end).format('YYYY-MM-DD'),
                        bill_type: type
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.busy = false;
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    if (type == 'shop') {
                        this.shopBills = res.data.data
                        // format data
                        this.shopBills = this.shopBills.map((b) => {
                            return {
                                ...b,
                                // net_commission: parseFloat(parseFloat(parseFloat(b.exclude_vat) - parseFloat(b.withholding_tax)).toFixed(2)),
                                bank_code: b.acc_info[0].account_bank,
                                bank_name: this.bankName[b.acc_info[0].account_bank].name,
                                bank_branch: b.acc_info[0].branch_code,
                                bank_account: b.acc_info[0].account_id,
                                account_name: b.acc_info[0].account_name,
                            };
                        })
                        this.shopBillTotal = res.data.data.length
                    } else if (type == 'superadmin') {
                        this.superAdminBills = res.data.data
                        // format data
                        this.superAdminBills = this.superAdminBills.map((b) => {
                            return {
                                ...b,
                                net_commission: parseFloat(parseFloat(parseFloat(b.exclude_vat) - parseFloat(b.withholding_tax)).toFixed(2)),
                                bank_code: b.acc_info[0].account_bank,
                                bank_name: this.bankName[b.acc_info[0].account_bank].name,
                                bank_branch: b.acc_info[0].branch_code,
                                bank_account: b.acc_info[0].account_id,
                                account_name: b.acc_info[0].account_name,
                            };
                        })
                        this.superAdminBillTotal = res.data.data.length
                    }

                    this.busy = false
                    this.applyFilter()
                });
        },
    },
    events: {
        'select-item': (allItems) => {
            this.items = allItems
        }
    }
}
</script>